
import { Component } from 'react';

import {
    createRecordingDialogEvent,
    sendAnalytics
} from '../../../analytics';
import { stopLocalVideoRecording } from '../../actions.any';

/**
 * The type of the React {@code Component} props of
 * {@link AbstractStopLocalRecordingDialog}.
 */
export type Props = {

    /**
     * The redux dispatch function.
     */
    dispatch: Function,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
};

/**
 * Abstract React Component for getting confirmation to stop a local recording
 * session in progress.
 *
 * @augments Component
 */
export default class AbstractStopLocalRecordingDialog<P: Props>
    extends Component<P> {
    /**
     * Initializes a new {@code AbstractStopLocalRecordingDialog} instance.
     *
     * @inheritdoc
     */
    constructor(props: P) {
        super(props);

        // Bind event handler so it is only bound once for every instance.
        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit: () => boolean;

    /**
     * Stops the local recording session.
     *
     * @private
     * @returns {boolean} - True (to note that the modal should be closed).
     */
    _onSubmit() {
        sendAnalytics(createRecordingDialogEvent('stop', 'confirm.button', {
            type: 'local'
        }));

        this.props.dispatch(stopLocalVideoRecording());

        return true;
    }
}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code StopLocalRecordingDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{}}
 */
export function mapStateToProps() {
    return {};
}
